import { render } from "./BootstrapModal.vue?vue&type=template&id=4465e1ae&scoped=true"
import script from "./BootstrapModal.vue?vue&type=script&lang=js"
export * from "./BootstrapModal.vue?vue&type=script&lang=js"

import "./BootstrapModal.vue?vue&type=style&index=0&id=4465e1ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4465e1ae"]])

export default __exports__